/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zoom_Percentage_ValueInputs */

const en_zoom_percentage_value = /** @type {(inputs: Zoom_Percentage_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom percentage value`)
};

const fr_zoom_percentage_value = /** @type {(inputs: Zoom_Percentage_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valeur du pourcentage de zoom`)
};

const de_zoom_percentage_value = /** @type {(inputs: Zoom_Percentage_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom-Prozentwert`)
};

const it_zoom_percentage_value = /** @type {(inputs: Zoom_Percentage_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valore percentuale dello zoom`)
};

const ru_zoom_percentage_value = /** @type {(inputs: Zoom_Percentage_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`значение процента масштабирования`)
};

const es_zoom_percentage_value = /** @type {(inputs: Zoom_Percentage_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor porcentual de zoom`)
};

const zh_cn2_zoom_percentage_value = /** @type {(inputs: Zoom_Percentage_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`缩放百分比值`)
};

const ja_zoom_percentage_value = /** @type {(inputs: Zoom_Percentage_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ズーム率の値`)
};

const hi_zoom_percentage_value = /** @type {(inputs: Zoom_Percentage_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ज़ूम प्रतिशत मान`)
};

const pt_pt2_zoom_percentage_value = /** @type {(inputs: Zoom_Percentage_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor percentual do zoom`)
};

/**
* | output |
* | --- |
* | "Zoom percentage value" |
*
* @param {Zoom_Percentage_ValueInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const zoom_percentage_value = /** @type {((inputs?: Zoom_Percentage_ValueInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zoom_Percentage_ValueInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_zoom_percentage_value(inputs)
	if (locale === "de") return de_zoom_percentage_value(inputs)
	if (locale === "it") return it_zoom_percentage_value(inputs)
	if (locale === "ru") return ru_zoom_percentage_value(inputs)
	if (locale === "es") return es_zoom_percentage_value(inputs)
	if (locale === "zh-CN") return zh_cn2_zoom_percentage_value(inputs)
	if (locale === "ja") return ja_zoom_percentage_value(inputs)
	if (locale === "hi") return hi_zoom_percentage_value(inputs)
	if (locale === "pt-PT") return pt_pt2_zoom_percentage_value(inputs)
	return en_zoom_percentage_value(inputs)
});